export const passwordimport = {
  headerTitle: 'Kennwortimport',
  route: 'passwordimport',
  pageTitle: 'paed.ML - Kennwort Import',
  related: [
    { route: 'jobverwaltung/jobs', menuTitle: 'Jobs ansehen' },
    { route: 'benutzerverwaltung/lehrerinnen', menuTitle: 'Existierende / importierte Lehrer*innen anschauen' },
    { route: 'benutzerverwaltung/schuelerinnen', menuTitle: 'Existierende / importierte Schüler*innen anschauen' },
    { route: 'benutzerverwaltung/schularten', menuTitle: 'Schulen anlegen' },
  ],
  cards: [
    { 
      route: 'teachers',
      icon: 'passwort-bearbeiten-g',
      endpoint: '/api/import/password/teachers',
      endpoints: {
        post: '/api/import/password',
        delete: '/api/import/password',
      },
      preHooks: {
        list: 'password_imports_list_preHook'
      },
      tag: 'paedml-card-passwordimport',
      category: 'ImportPassword',
      menuTitle: 'Lehrer*innen',
      pageTitle: 'paed.ML - Kennwort Lehrer*innen importieren',
      name: 'importkennwortlehrer',
      contentTitle: 'Lehrer*innen',
      prefix: 'importkennwortlehrer',
      suffix: undefined,
      custom: {
        usergroup: 1,
        variant: 'teacher'
      },
      table: {
        columns: [
          { title: '', name: 'icon', col: 0, priority: 1, searchable: false, printable: false, exportable: false, orderable: false, fnCreatedCell: (td, val) => val ? $(td).html(`<svg class="paedml-icon black" style="margin-top: -3px"><use xlink:href="#${val}" /></svg>`) : '' },
          { title: 'ID', name: 'id', col: 1, priority: 5 },
          { title: 'schoolTypeId', name: 'schoolTypeId', col: 2, visible: false, searchable: false, printable: false, exportable: false },
          { title: 'Schule', name: 'schoolType', col: 3, filter: 'Schule', priority: 10, filterType: 'regex' },
          { title: 'Benutzername', name: 'userName', col: 4, priority: 10 },
          { title: 'Nachname', name: 'surname', col: 5, priority: 10 },
          { title: 'Vorname', name: 'givenName', col: 6, priority: 9 },
          { title: 'passwordPolicy', name: 'passwordPolicy', col: 7, visible: false, searchable: false, printable: false, exportable: false },
          { title: 'Kennwortoption', name: 'passwordPolicyDp', col: 8, priority: 3 },
          { title: 'Kennwort', name: 'password', col: 9, priority: 2 },
          { title: 'Externe ID', name: 'externalId', col: 10, priority: 10 },
          { title: 'Externe ID verifiziert', name: 'externalIdVerified', col: 11, priority: 4 },
          { title: 'Vermerk', name: 'vermerk', col: 12, priority: 10, filter: 'Vermerk' },
          { title: 'delId', name: 'delId', col: 13, visible: false, searchable: false, printable: false, exportable: false },
          { title: 'errorType', name: 'errorType', col: 14, visible: false, searchable: false, printable: false, exportable: false },
        ],
        data: {},
        custom: {
          pageLength: 10,
          order: [[ 1, 'asc' ]],
          select: {
            style: 'multi+shift'
          }
        }
      }
    },

    { 
      route: 'students',
      icon: 'passwort-bearbeiten-g',
      endpoint: '/api/import/password/students',
      endpoints: {
        post: '/api/import/password',
        delete: '/api/import/password',
      },
      preHooks: {
        list: 'password_imports_list_preHook'
      },
      tag: 'paedml-card-passwordimport',
      category: 'ImportPassword',
      menuTitle: 'Schüler*innen',
      pageTitle: 'paed.ML - Kennwort Schüler*innen importieren',
      name: 'importkennwortschueler',
      contentTitle: 'Schüler*innen',
      prefix: 'importkennwortschueler',
      suffix: undefined,
      custom: {
        usergroup: 0,
        variant: 'student'
      },
      table: {
        columns: [
          { title: '', name: 'icon', col: 0, priority: 1, searchable: false, printable: false, exportable: false, orderable: false, fnCreatedCell: (td, val) => val ? $(td).html(`<svg class="paedml-icon black" style="margin-top: -3px"><use xlink:href="#${val}" /></svg>`) : '' },
          { title: 'ID', name: 'id', col: 1, priority: 5 },
          { title: 'schoolTypeId', name: 'schoolTypeId', col: 2, visible: false, searchable: false, printable: false, exportable: false },
          { title: 'Schule', name: 'schoolType', col: 3, filter: 'Schule', priority: 10, filterType: 'regex' },
          { title: 'Benutzername', name: 'userName', col: 4, priority: 10 },
          { title: 'Nachname', name: 'surname', col: 5, priority: 10 },
          { title: 'Vorname', name: 'givenName', col: 6, priority: 9 },
          { title: 'passwordPolicy', name: 'passwordPolicy', col: 7, priority: 3, visible: false, searchable: false, printable: false, exportable: false },
          { title: 'Kennwortoption', name: 'passwordPolicyDp', col: 8, priority: 3 },
          { title: 'Kennwort', name: 'password', col: 9, priority: 2 },
          { title: 'Externe ID', name: 'externalId', col: 10, priority: 10 },
          { title: 'Externe ID verifiziert', name: 'externalIdVerified', col: 11, priority: 4 },
          { title: 'Vermerk', name: 'vermerk', col: 12, priority: 10, filter: 'Vermerk' },
          { title: 'delId', name: 'delId', col: 13, visible: false, searchable: false, printable: false, exportable: false },
          { title: 'errorType', name: 'errorType', col: 14, visible: false, searchable: false, printable: false, exportable: false },
        ],
        data: {},
        custom: {
          pageLength: 10,
          order: [[ 1, 'asc' ]],
          select: {
            style: 'multi+shift'
          }
        }
      }
    },

  ]
}